import { useAppSelector } from "@src/reduxStore";
import { useTopMenu } from "@src/common/reliablePartnerApi";
import LazyStvUtilsFrontend from "@src/LazyStvUtilsFrontend";

const Footer = () => {
  const language = useAppSelector(state => state.common.language);
  const topMenuResponse = useTopMenu();

  switch (topMenuResponse.status) {
    case "idle":
    case "loading":
      return null;
    case "error":
      throw topMenuResponse.error;
    case "success":
      return (
        <LazyStvUtilsFrontend>
          {({ FooterComponent }) => (
            <FooterComponent
              selectedLanguageCode={language}
              configuration={topMenuResponse.data.configuration}
            />
          )}
        </LazyStvUtilsFrontend>
      );
  }
};

export default Footer;
